<template>
  <div v-show='isActive'>
    <div class="relative my-6 md:my-8">
      <div class="absolute inset-0 flex items-center" aria-hidden="true">
        <div class="w-full border-t border-blue-600"></div>
      </div>
      <div class="relative flex justify-center">
        <span class="px-2 bg-white text-lg font-semibold text-blue-500 capitalizes">
          {{ title }}
        </span>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "AssortmentTab",
  props: {
    title: String,
    image: String,
    icon: String
  },
  data () {
    return {
      isActive: false
    }
  }
}
</script>